export enum Priority {
  high,
  medium,
  low
}

export class PriorityManager {
  static readonly values = Object.keys(Priority).filter(prio => isNaN(Number(prio)));
  static readonly len = this.values.length;
}